import { AnyAction } from "redux";
import { CategoryState } from "../types/categoryTypes";
import {
  FETCH_CATEGORIES_FAILURE,
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
} from "../actions/categoryAction";

const initialState: CategoryState = {
  categoriesData: { categories: [] },
  loading: false,
  error: null,
};

const categoryReducer = (
  state = initialState,
  action: AnyAction
): CategoryState => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        categoriesData: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_CATEGORIES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    // Handle other item-related actions here...
    default:
      return state;
  }
};

export default categoryReducer;
